module.exports = __webpack_public_path__ + "img/deleted.784ed0b0.png";